import { applyMiddleware, compose, createStore } from "redux";
import { persistStore, persistCombineReducers } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import rootReducer from "./index";

const logger = createLogger({ collapsed: true });

const persistConfig = {
    key: "root",
    storage,
    whitelist: [],
};

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistedReducer = persistCombineReducers(persistConfig, rootReducer);

let store = createStore(
    persistedReducer,
    composeEnhancers(
        applyMiddleware(thunk, logger /*routerMiddleware(history)*/),
    ),
);
declare global {
    type RootState = ReturnType<typeof store.getState>;
}

const persistedStore = () => {
    let persistor = persistStore(store);
    return { store, persistor };
};
let definitiveStore = persistedStore();

export type RootState = ReturnType<typeof store.getState>;

export default definitiveStore;
